module.exports = __webpack_public_path__ + "img/calendar-filter.53b47d02.svg";